import { render, staticRenderFns } from "./NotificationsConfigModal.vue?vue&type=template&id=72f192bc&scoped=true"
import script from "./NotificationsConfigModal.vue?vue&type=script&lang=js"
export * from "./NotificationsConfigModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationsConfigModal.vue?vue&type=style&index=0&id=72f192bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f192bc",
  null
  
)

export default component.exports